function Title({ title = "" }) {
  return (
    <div className="flex w-full text-[#212529] text-[25px] mx-20">{title}</div>
  );
}
export default Title;
